import { Top } from "@/features/dashboard/top/Top";
import { createFileRoute } from "@tanstack/react-router";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_dashboard/")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("ダッシュボード");

  return <Top />;
}
